import { SET_STATE, RESET, PARTICIPANT_JOINED, PARTICIPANT_LEFT, PARTICIPANT_USER_ID_KNOWN, SET_FILM_STRIP_DISPLAY, SET_SCREEN_SHARE, SET_IGNORE_DEVICE_WARNING, SHOW_RECORDING_INSTRUCTIONS, CLOSE_RECORDING_INSTRUCTIONS, VIDEO_CONFERENCE_JOINED, DOMINANT_SPEAKER_CHANGED } from './actionTypes'
import _omit from 'lodash/omit'
import { setState } from '../workoutTogether/actions'


function initialState( preserve = {} ) {
    return Object.assign({},{
      loading : false,
      showManageGym : false,
      showRecordingInstructions : false,
      visible : false,
      onCall : false,
      dockToSide : false,
      muted : false,
      videoMuted:false,
      screenShared : false,
      screenShareSource : null,
      filmStripVisible : true,
      moreActionsVisible : true,
      meetApi : null,
      videoConferenceInfo : {},
      dominantSpeaker : {},
      participants : {},
      participantsByUserId : {},
      isGym : false,
      gym : null,
      ignoreDeviceSupportWarning:false
    }, preserve )
}

  export default function (state = initialState(), action) {

    switch (action.type) {

        case SET_STATE:

            const newState = action.newState
            
            for ( var key in newState ) {
                if ( newState.hasOwnProperty( key ) && state.hasOwnProperty( key ) ) {
                    state[key] = newState[key]
                }
            }
            

            break

        case VIDEO_CONFERENCE_JOINED:

            state.videoConferenceInfo = action.videoConferenceInfo

            break;

        case DOMINANT_SPEAKER_CHANGED:

            state.dominantSpeaker = action.dominantSpeaker

            break;

        case PARTICIPANT_JOINED:

            const joinedParticipants = Object.assign( {}, state.participants, { [ action.participant.id ] : action.participant } )

            state.participants = joinedParticipants

            break

        case PARTICIPANT_USER_ID_KNOWN:

            if ( state.participants[ action.participant.id ] && action.participant.userId ) {
                state.participants[ action.participant.id ].userId=action.participant.userId
                state.participants[ action.participant.id ].avatar=action.participant.avatar
                state.participants = Object.assign( {}, state.participants )
                state.participantsByUserId = Object.assign( {}, state.participantsByUserId, { [  action.participant.userId ] : state.participants[ action.participant.id ] } )
            }

            break
        
        case PARTICIPANT_LEFT:

            if (  state.participants[ action.participant.id ] && state.participants[ action.participant.id ].userId ) state.participantsByUserId = _omit( state.participantsByUserId, state.participants[ action.participant.id ].userId )
            state.participants = _omit( state.participants, action.participant.id )


            break

        case SET_FILM_STRIP_DISPLAY:

            state.filmStripVisible = action.visible
            
            break

        case SET_SCREEN_SHARE:
            state.screenShared = action.screenShareState.on
            state.screenShareDetails = ( ( !action.screenShareState.on && null ) || action.screenShareState.details )

            break

        case SET_IGNORE_DEVICE_WARNING:
            state.ignoreDeviceSupportWarning = action.ignoreDeviceSupportWarning
            break;
        case SHOW_RECORDING_INSTRUCTIONS:
            state.showRecordingInstructions = true
            break;
        case CLOSE_RECORDING_INSTRUCTIONS:
            state.showRecordingInstructions = false
            break;
        case RESET : 

            state = initialState( { ignoreDeviceSupportWarning : state.ignoreDeviceSupportWarning })
        
            break
            
        default:
    }

    return state;
  }
